document.addEventListener("DOMContentLoaded", function(){

  const filters = document.querySelectorAll(".filter-button");

  filters.forEach(button => {

    button.addEventListener("click", function(e){

      e.preventDefault();

      const category = this.dataset.category;

      const newUrl = "/pages/spa-services?category=" + category;

      window.history.pushState({}, "", newUrl);

    });

  });

});